function i(c) {
  let e = !1;
  const o = new Promise((a, r) => {
    c.then((n) => {
      e && r(l), a(n);
    }).catch((n) => {
      e && r(l), r(n);
    });
  });
  function s() {
    e = !0;
  }
  return {
    promise: o,
    cancel: s
  };
}
class t extends Error {
  /**
    * @param {string} [message] The message of the error
    */
  constructor(e) {
    super(e), this.name = "CancelError";
  }
}
const l = new t("Promise was cancelled");
export {
  l as CancelledPromiseError,
  i as createCancellablePromise
};
